/* global APPLICATION_CONFIG */

import c from "./consts";
import http from "@/api/http";

export default {
  async [c.LOGIN]({ commit }, payload) {
    try {
      await http.post(
          `${APPLICATION_CONFIG.api.authURL}/login`,
          {
            login: payload.login,
            password: payload.password,
          },
          {
            skipAuthRefresh: true,
          }
      );

      return true;
    }
    catch {
      commit(c.CURRENT_USER, null);
      return false;
    }
  },

  async [c.GET_CURRENT_USER]({ commit }) {
    try {
      const result = await http.get(
          `${APPLICATION_CONFIG.api.authURL}/get-current-user`
      );

      commit(c.CURRENT_USER, result.data);

      return result.data;
    }
    catch {
      commit(c.CURRENT_USER, null);
      return null;
    }
  },

  async [c.LOGOUT]({ commit }) {
    try {
      await http.post(
          `${APPLICATION_CONFIG.api.authURL}/logout`,
          {},
          {
            skipAuthRefresh: true,
          }
      );
    }
    finally {
      commit(c.CURRENT_USER, null);
    }
  },

  async [c.CHANGE_PASSWORD]({ commit }, payload) {
    try {
      await http.put(
          `${APPLICATION_CONFIG.api.authURL}/password`,
          {
            currentPassword: payload.currentPassword,
            newPassword: payload.newPassword,
          }
      );

      commit(c.CURRENT_USER, null);

      return {
        success: true,
      };
    }
    catch (error) {
      return {
        success: false,
        message:
            error.response?.data?.message ||
            "Не удалось изменить пароль",
      };
    }
  },

  async [c.INITIALIZE_AUTH]({state, commit, dispatch}) {
    if (state[c.AUTH_INITIALIZED]) {
      return state[c.CURRENT_USER];
    }

    try {
      return await dispatch(c.GET_CURRENT_USER);
    }
    finally {
      commit(c.AUTH_INITIALIZED, true);
    }
  },
};